import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { TabsComponent as Tabs } from '@enechain/ecloud-designsystem'

import { PageBody } from '~/components/common/PageBody'
import { PageLayout } from '~/components/common/PageLayout'
import { tabTriggerFontSize } from '~/constants/tabStyle'
import { GenerationSiteTab } from '~/pages/AdminPlantUnitMaster/components/GenerationSiteTab'
import { PlantUnitTab } from '~/pages/AdminPlantUnitMaster/components/PlantUnitTab'
import { routePaths } from '~/routes/routePaths'

type TabKey = 'unit' | 'site'

/**
 * 電源ユニット画面 (`/admin/plant-unit-master`)。「電源ユニット」タブ (既定) は発電所ごとに
 * まとめたユニットの一覧・登録・削除、「発電所」タブは自社の発電所 (サイト) のマスタ。
 * 選んだタブだけを mount する (タブを切り替えるとフィルタ条件はリセットされる)。
 */
export const AdminPlantUnitMasterPage = (): React.ReactElement => {
  const { t } = useTranslation()
  const [tab, setTab] = useState<TabKey>('unit')
  const tabs: Array<{ key: TabKey; label: string }> = [
    { key: 'unit', label: t('page:adminPlantUnitMaster.tabs.unit') },
    { key: 'site', label: t('page:adminPlantUnitMaster.tabs.site') },
  ]

  return (
    <PageLayout
      breadcrumbItems={[
        {
          label: t('page:adminPlantUnitMaster.breadcrumb.admin'),
          to: routePaths.adminHub.path,
        },
        { label: t('common:route.adminPlantUnitMaster'), bold: true },
      ]}
    >
      <PageBody>
        <Tabs
          items={tabs}
          onSelect={(key) => setTab(key === 'site' ? 'site' : 'unit')}
          selected={tab}
          tabSx={{ fontSize: tabTriggerFontSize.raw }}
        />
        {tab === 'unit' ? <PlantUnitTab /> : <GenerationSiteTab />}
      </PageBody>
    </PageLayout>
  )
}
